export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-background-100">
        <img
          src="https://readdy.ai/api/search-image?query=cinematic%20warm%20amber%20golden%20lighting%20with%20abstract%20film%20reel%20and%20stage%20spotlight%20elements%2C%20modern%20entertainment%20atmosphere%2C%20dark%20theater%20background%20with%20dramatic%20light%20beams%2C%20clean%20minimalist%20composition%2C%20warm%20orange%20and%20deep%20charcoal%20color%20palette%2C%20premium%20editorial%20style&width=1600&height=1000&seq=hero-cinema-main&orientation=landscape"
          alt="极速影院主视觉 - 免费综艺节目在线观看平台"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 mb-4">
              <span className="px-3 py-1.5 rounded-full bg-primary-500/90 text-background-50 text-xs font-semibold whitespace-nowrap">
                综艺大全
              </span>
              <span className="px-3 py-1.5 rounded-full bg-accent-500/90 text-background-50 text-xs font-semibold whitespace-nowrap">
                每日更新
              </span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-black text-background-50 font-heading leading-tight">
              极速影院
              <span className="block text-xl md:text-2xl lg:text-3xl font-bold mt-2 text-primary-300">
                免费综艺节目高清在线观看
              </span>
            </h1>

            <p className="mt-3 text-base md:text-lg text-background-200/90 font-medium">
              不缓冲 · 无广告 · 全免费
            </p>

            <p className="mt-5 text-sm md:text-base text-background-200/80 max-w-xl leading-relaxed">
              极速影院汇聚全网最新热门综艺节目，涵盖音乐竞技、户外真人秀、脱口秀、选秀才艺、美食旅行等多种类型。
              高清画质搭配智能加速技术，让每一次观看都流畅不卡顿。每日同步更新，不错过任何一期精彩内容。
              无论你是综艺达人还是偶尔消遣，极速影院都是你的最佳娱乐伴侣。
            </p>

            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-6">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-primary-500/20 flex items-center justify-center">
                  <i className="ri-play-circle-fill text-primary-400 text-base"></i>
                </div>
                <span className="text-sm text-background-200 font-medium">2000+ 综艺节目</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-accent-500/20 flex items-center justify-center">
                  <i className="ri-4k-fill text-accent-400 text-base"></i>
                </div>
                <span className="text-sm text-background-200 font-medium">1080P 高清画质</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-primary-500/20 flex items-center justify-center">
                  <i className="ri-refresh-line text-primary-400 text-base"></i>
                </div>
                <span className="text-sm text-background-200 font-medium">每日同步更新</span>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 rounded-xl bg-primary-500 hover:bg-primary-600 text-background-50 font-bold text-sm transition-colors whitespace-nowrap text-center cursor-pointer"
              >
                <i className="ri-play-circle-line mr-2"></i>
                开始观看
              </a>
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 rounded-xl border-2 border-background-200/40 hover:border-background-200/70 text-background-50 font-semibold text-sm transition-colors whitespace-nowrap text-center cursor-pointer"
              >
                <i className="ri-grid-line mr-2"></i>
                综艺分类
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=modern%20entertainment%20streaming%20interface%20showing%20variety%20show%20thumbnails%20with%20warm%20cinematic%20color%20tones%2C%20sleek%20dark%20UI%20design%20with%20golden%20accents%2C%20show%20posters%20array%20with%20stage%20lights%2C%20premium%20streaming%20platform%20mockup%2C%20editorial%20design%20with%20soft%20glow%20effects&width=1200&height=900&seq=hero-showcase&orientation=landscape"
                alt="极速影院综艺节目浏览界面展示"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 border border-background-200/15 rounded-2xl pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}